import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernygateway';

class UserJournalService extends ServiceBase {
    /**
     * Fetches journals for the current user, empty values are ignored by the BE.
     * @param {string} type
     * @param {string} serviceName
     * @param {string} cat
     * @param {string} parentRK
     * @param {string} format
     * @param {number} limit
     * @param {boolean} includeDeleted
     * @returns {Promise}
     */
    getJournals = (type = '', serviceName = '', cat = '', parentRK = '', format = '', limit = 100, includeDeleted = false) => {
        const url = `${baseUrl}/${service}/user/journals?type=${type}&service=${serviceName}&cat=${cat}&parentRK=${parentRK}&format=${format}&limit=${limit}&includeDeleted=${includeDeleted}`;
        const cfg = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, cfg);
    };
}

const userJournalService = new UserJournalService();
export default userJournalService;
